import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CompanyProfileSection = ({ formData, errors, onChange }) => {
  const businessSizeOptions = [
    { value: 'solo', label: 'Solo Entrepreneur (1 person)' },
    { value: 'micro', label: 'Micro Business (2-9 employees)' },
    { value: 'small', label: 'Small Business (10-49 employees)' },
    { value: 'medium', label: 'Medium Business (50-249 employees)' },
    { value: 'large', label: 'Large Enterprise (250+ employees)' }
  ];

  const organizationalStructureOptions = [
    { value: 'flat', label: 'Flat Organization' },
    { value: 'hierarchical', label: 'Hierarchical Structure' },
    { value: 'matrix', label: 'Matrix Organization' },
    { value: 'divisional', label: 'Divisional Structure' },
    { value: 'network', label: 'Network Organization' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Building2" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-xl sm:text-2xl font-semibold text-foreground font-heading">
            Company Profile Collection
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground mt-1">
            Tell us about your business to help our AI agents provide personalized assistance
          </p>
        </div>
      </div>

      <div className="space-y-6">
        <Input
          type="text"
          label="Business Name"
          description="Legal or trading name of your company"
          placeholder="Enter your company name"
          value={formData?.companyName || ''}
          onChange={(e) => onChange('companyName', e?.target?.value)}
          error={errors?.companyName}
          required
        />

        <Select
          label="Business Size"
          description="Number of employees in your organization"
          placeholder="Select business size"
          options={businessSizeOptions}
          value={formData?.businessSize || ''}
          onChange={(value) => onChange('businessSize', value)}
          error={errors?.businessSize}
          required
        />

        <Input
          type="date"
          label="Founding Date"
          description="When was your company established? (Optional)"
          value={formData?.foundingDate || ''}
          onChange={(e) => onChange('foundingDate', e?.target?.value)}
        />

        <Select
          label="Organizational Structure"
          description="How is your company organized? (Optional)"
          placeholder="Select organizational structure"
          options={organizationalStructureOptions}
          value={formData?.organizationalStructure || ''}
          onChange={(value) => onChange('organizationalStructure', value)}
        />
      </div>

      <div className="p-4 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Lightbulb" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm text-muted-foreground flex-1 min-w-0">
            <p className="font-medium text-foreground mb-1">Why we need this information:</p>
            <p>
              Your company profile helps our AI agents understand your business context, enabling them to provide
              tailored recommendations, content, and strategies that align with your organization's size and structure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyProfileSection;